import {
  INITIAL_PROYECTOS_WELCOME,
  LOADING_WELCOME,
  INGRESO_WELCOME,
  IMAGES_WELCOME,
  CACHED_IMAGES,
  PROYECTOS_WELCOME,
  TEXTURES_WELCOME,
  LOADED_IMAGES_WELCOME,
  STEP_WELCOME
} from '../actions';


export const initialProyectosWelcome = () => ({
  type: INITIAL_PROYECTOS_WELCOME
});
export const imagesWelcome = () => ({
  type: IMAGES_WELCOME
});
export const loadingWelcome = (payload) => ({
  type: LOADING_WELCOME,
  payload: payload
});
export const ingresoWelcome = (payload) => ({
  type: INGRESO_WELCOME,
  payload: payload
});
export const cachedImagesWelcome = (payload) => ({
  type: CACHED_IMAGES,
  payload: payload
});
export const proyectosWelcome = (payload) => ({
  type: PROYECTOS_WELCOME,
  payload: payload
});
export const texturesWelcome = (payload) => ({
  type: TEXTURES_WELCOME,
  payload: payload
});
export const loadedImagesWelcome = (payload) => ({
  type: LOADED_IMAGES_WELCOME,
  payload: payload
});
export const stepWelcome = (payload) => ({
  type: STEP_WELCOME,
  payload: payload
});
/* export const loginUserSuccess = (user) => ({
  type: LOGIN_USER_SUCCESS,
  payload: user
});
export const loginUserError = (message) => ({
  type: LOGIN_USER_ERROR,
  payload: { message }
});

export const forgotPassword = (forgotUserMail, history) => ({
  type: FORGOT_PASSWORD,
  payload: { forgotUserMail, history }
});
export const forgotPasswordSuccess = (forgotUserMail) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: forgotUserMail
});
export const forgotPasswordError = (message) => ({
  type: FORGOT_PASSWORD_ERROR,
  payload: { message }
});

export const resetPassword = ({resetPasswordCode,newPassword,history}) => ({
  type: RESET_PASSWORD,
  payload: { resetPasswordCode,newPassword,history }
});
export const resetPasswordSuccess = (newPassword) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload: newPassword
});
export const resetPasswordError = (message) => ({
  type: RESET_PASSWORD_ERROR,
  payload: { message }
});


export const logoutUser = (history) => ({
  type: LOGOUT_USER,
  payload: { history }
}); */